import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, throwError } from 'rxjs';
import { SharedService } from '../../shared/services/shared.service';

export const authInterceptor: HttpInterceptorFn = (request: any, next) => {
    // Get the access token from the authentication service
    const accessToken = sessionStorage.getItem('access_token')
    const router = inject(Router);
    const toasterService = inject(ToastrService);
    const msalService = inject(MsalService);
    const sharedService = inject(SharedService);
    
    // Clone the request and attach the access token to the Authorization header
    if (accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }
  return next(request).pipe(
                    
    catchError((error: HttpErrorResponse) => {
        // Check for CORS error (it is usually a network error)
        if (error.status === 0) {
          // Handle CORS error
          console.error('CORS error:', error);
          toasterService.error('Access restricted. Please contact admin for assistance.');
          let accounts = msalService.instance.getAllAccounts().length;
          sharedService.logout();
          if(accounts > 0){
            msalService.logoutRedirect();
          }

          setTimeout(()=>{
            router.navigate(['/login']).then(() => {
              window.location.reload();
            });
          }, 2000);
          return throwError(() => new Error('Access restricted. Please contact admin for assistance.'));
        }

        // Check for UNAUTHORIZED error (it is usually a network error)
        if (error.status === 401 && !request.headers.get('skip')) {
            toasterService.error("Error! Please try again", "Error");
            sharedService.logout();
            
        }

        // Check for FORBIDDEN error
        if (error.status === 403 && !request.headers.get('skip')) {
          sharedService.logout();
        }

        if(error.error?.message || error.message){
          return throwError(error);
        }
        else{
          return throwError(() => new Error('Unexpected error occurred. Please contact your admin.'));
        }
      }),
    finalize(() => {}));
};